/**
 * NASHE Header JavaScript
 * Handles mobile menu toggle functionality
 */

(function() {
  'use strict';

  function initNasheHeader() {
    const headers = document.querySelectorAll('.nashe-header');

    headers.forEach(function(header) {
      const toggle = header.querySelector('[data-menu-toggle]');
      const mobileMenu = header.querySelector('.nashe-header__mobile-menu');
      const mobileLinks = header.querySelectorAll('.nashe-header__mobile-link');

      if (!toggle || !mobileMenu) return;

      // Toggle menu on button click
      toggle.addEventListener('click', function() {
        const isOpen = header.getAttribute('data-menu-open') === 'true';
        const newState = !isOpen;

        header.setAttribute('data-menu-open', newState);
        toggle.setAttribute('aria-expanded', newState);
        mobileMenu.setAttribute('aria-hidden', !newState);

        // Prevent body scroll when menu is open
        if (newState) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });

      // Close menu when clicking a link
      mobileLinks.forEach(function(link) {
        link.addEventListener('click', function() {
          header.setAttribute('data-menu-open', 'false');
          toggle.setAttribute('aria-expanded', 'false');
          mobileMenu.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });

      // Close menu on escape key
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && header.getAttribute('data-menu-open') === 'true') {
          header.setAttribute('data-menu-open', 'false');
          toggle.setAttribute('aria-expanded', 'false');
          mobileMenu.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          toggle.focus();
        }
      });

      // Close menu on window resize to desktop
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          if (window.innerWidth >= 768 && header.getAttribute('data-menu-open') === 'true') {
            header.setAttribute('data-menu-open', 'false');
            toggle.setAttribute('aria-expanded', 'false');
            mobileMenu.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        }, 100);
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNasheHeader);
  } else {
    initNasheHeader();
  }

  // Re-initialize on Shopify section load/unload (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('nashe-header-section')) {
      initNasheHeader();
    }
  });
})();
